module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJwdWJsaWMvZm9udHMvZm9udGF3ZXNvbWUtd2ViZm9udC5zdmciOw=="